import React, { useState, useEffect, useMemo } from "react";
import {
  CitySelect,
  CountrySelect,
  StateSelect,
  LanguageSelect,
  RegionSelect,
  PhonecodeSelect,
} from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";

import { useDispatch, useSelector } from "react-redux";
import { addwebOrder } from "../../../redux/api/website/WebOrdersApi";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { getWebOrder } from "../../../redux/reduxApi/website/OrdersReduxApi";
import Select, { components } from "react-select";

import { getCoustomerAdderss } from "../../../redux/reduxApi/website/CoustomerAdderssrapi";
import { getShippingPrice } from "../../../redux/api/website/ShipstationApi";
import { v4 as uuidv4 } from "uuid";
import { PaymentCheckApi } from "../../../redux/api/website/PaymentApi";

import StripePayment from "./StripePayment";
import { addCoustomerAddresses } from "../../../redux/api/website/CoustomerAddressesApi";
import {
  CreateShipmentApi,
  ShipmentOrdersApi,
} from "../../../redux/api/website/StalionApi";

const CheckoutPage = (props) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const userAddresses = useSelector(
    (state) => state.CoustomerAddress.CoustomerAddress.address || []
  );
  const [showNewAddress, setShowNewAddress] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  // console.log("Received state in CheckoutPage:", location.state);
  const [country, setCountry] = useState(null);
  const [currentState, setCurrentState] = useState(null);
  const [currentCity, setCurrentCity] = useState(null);
  const [orderSubmitted, setOrderSubmitted] = useState(false);
  const { subtotal, cartItems } = location.state || {};
  console.log("data  CheckoutPage:", location.state);
  const [differentAddress, setDifferentAddress] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const cartData = useSelector((state) => state.Cart.CartProducts);
  const [quantities, setQuantities] = useState({});
  const [currency, setCurrency] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  // Add this state
  const [clientSecret, setClientSecret] = useState("");
  const [showStripeForm, setShowStripeForm] = useState(false);
  const [priceSummaryData, setPriceSummaryData] = useState({
    Total: "",
    SubTotal: " ",
    ShippingCost: "",
  });
  // localStorage.getItem("UserRowId");
  // console.log("localStorage",localStorage.getItem("UserRowId"))
  const [orderData, setOrderData] = useState([]);
  const [dataOrder, setDataOrder] = useState([]);
  // const [shipstationData, setShipstationData] = useState();
  const [shipstationData, setShipstationData] = useState(null);
  const [selectedShippingOption, setSelectedShippingOption] = useState(null);
  const [shipmentOrderId, setShipmentOrderID] = useState();
  // const [createShipmentPaylod, setCreateShipmentPaylod] = useState();
  const getOrders = useSelector((state) => state.order.order);
    const UserData = useSelector((state) => state.SingIn?.SingIn);
    const [user, setUser] = useState({
      userId: "",
      UserEmail: "",
      UserName: "",
      UserMobile: "",
      UserFirstName: "",
      UserLastName: "",
    });
    console.log("this is user data", UserData);
  
    
  
  // console.log("getOrders?????????????????", getOrders);
  const [formData, setFormData] = useState({
    customerId: localStorage.getItem("customerId"),
    notes: "",
    currency: "",
    discount: "",
    shippingCost: "",
    taxAmount: "",
    subtotalAmount: "",
    status: "pending",
    totalAmount: "",
    paymentMethod: "",
    shippingAddress: {
      name: "",
      address: "",
      city: "",
      postal_code: "",
      country: "",
    },
    billingAddress: {
      fullName: "",
      address: "",
      city: "",
      postal_code: "",
      country: "",
      phone: "",
      email: "",
      company: "",
      state: "",
      province_code: "",
      address2: "",
      address1: "",
    },
    items: [
      {
        productId: "",
        productName: "",
        shippingCost: "",
        quantity: "",
        unitPrice: "",
        tax: "",
        image: "",
      },
    ],
  });
  useEffect(() => {
      if (UserData) {
        const customer = UserData?.data?.customerRes?.[0] || {};
        const userInfo = UserData?.user || {};
  
        setUser({
          userId: userInfo.ROWID || customer.ROWID || "",
          UserEmail: userInfo.email || customer.email || "",
          UserMobile: userInfo.phone || customer.phone || "",
          UserFirstName: userInfo.firstName || customer.firstName || "",
          UserLastName: userInfo.lastName || customer.lastName || "",
          UserName: `${userInfo.firstName || customer.firstName || ""} ${
            userInfo.lastName || customer.lastName || ""
          }`.trim(),
        });

        setFormData((prev)=>({...prev, billingAddress:{...prev.billingAddress, email:(userInfo.email || customer.email || "")}}))
      }
    }, [UserData]);
  const navigate = useNavigate();
  console.log("Received state in CheckoutPage:", location.state);

  useEffect(() => {
    const initialQuantities = {};
    cartData.cart?.forEach((product) => {
      initialQuantities[product.productId] = product.quantity;
    });
    setQuantities(initialQuantities);
  }, [cartData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const keys = name.split(".");

      if (keys.length === 2) {
        const [parent, field] = keys;
        return {
          ...prev,
          [parent]: {
            ...prev[parent],
            [field]: value,
          },
        };
      }

      return {
        ...prev,
        [name]: value,
      };
    });
  };

  useEffect(() => {
    if (location.state) {
      console.log("Updating formData with:", location.state);
      setFormData((prev) => ({
        ...prev,
        subtotalAmount: "",
        shippingCost: "",
        totalAmount: "",
        items: cartItems.map((item) => ({
          productId: item.productId,
          productName: item.part_type,
          shippingCost: item.shippingCost || 0,
          quantity: item.quantity || 1,
          unitPrice: item.price || 0,
          tax: item.tax || 0,
          totalPrice: (item.price || 0) * (item.quantity || 1),
          uniqueSerialNo: item.uniqueSerialNo,
          partKey: item.part_key,
          partType: item.part_type,
          image: item.image,
          width: item.width || 0,
          height: item.height || 0,
          length: item.length || 0,
          weight: item.weight || 0,
        })),
      }));
    }
  }, [location.state, subtotal,  cartItems]);

  useEffect(() => {
    dispatch(getCoustomerAdderss());
  }, [dispatch]);
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setIsSubmitting(true);
  //   try {
  //     // Declare updatedItems first
  //     const updatedItems =
  //       cartItems?.map((product) => ({
  //         productId: product.productId, // Ensure productId is included
  //         productName: product.name,
  //         shippingCost: product.shippingCost || "",
  //         quantity: product.quantity || 1,
  //         unitPrice: product.price || 0,
  //         tax: product.tax || 0,
  //         totalPrice: (product.price || 0) * (product.quantity || 1),
  //         uniqueSerialNo: product.uniqueSerialNo,
  //         partKey: product.part_key,
  //         partType: product.part_type,
  //       })) || [];

  //     const updatedFormData = {
  //       ...formData,
  //       subtotalAmount: subtotal,
  //       shippingCost: shippingCost,
  //       // taxAmount: tax,
  //       totalAmount: total,
  //       items: updatedItems, // No need for the ternary condition anymore
  //     };
  //     console.log("Updated formData:", updatedFormData);
  //     const res = await addwebOrder(updatedFormData);

  //     if (res.data.success) {
  //       const ROWID = res.data.orderId;
  //       dispatch(addOrdersAction({ ROWID, formData: updatedFormData }));
  //       toast.success("Order created successfully");
  //       setOrderSubmitted(true);
  //       dispatch(clearCartApi(localStorage.getItem("UserRowId")));

  //       // Reset form
  //       // setFormData({
  //       //   ...formData,
  //       //   // items: [],
  //       // });
  //     } else {
  //       toast.error("Error creating order");
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //     toast.error("An error occurred while creating the order");
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  // Update form data and dropdown states

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setIsSubmitting(true);

  //   if (!stripe || !elements) {
  //     setIsSubmitting(false);
  //     return;
  //   }

  //   try {
  //     const { error, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
  //       payment_method: {
  //         card: elements.getElement(PaymentElement),
  //         billing_details: {
  //           name: formData.billingAddress.name,
  //           address: {
  //             city: formData.billingAddress.city,
  //             country: formData.billingAddress.country,
  //             line1: formData.billingAddress.address,
  //             postal_code: formData.billingAddress.postal_code,
  //           },
  //           email: formData.billingAddress.email,
  //           phone: formData.billingAddress.phone,
  //         },
  //       },
  //     });

  //     if (error) throw error;

  //     if (paymentIntent.status === "succeeded") {
  //       // Prepare updatedItems
  //       const updatedItems =
  //         cartItems?.map((product) => ({
  //           productId: product.productId,
  //           productName: product.name,
  //           shippingCost: product.shippingCost || "",
  //           quantity: product.quantity || 1,
  //           unitPrice: product.price || 0,
  //           tax: product.tax || 0,
  //           totalPrice: (product.price || 0) * (product.quantity || 1),
  //           uniqueSerialNo: product.uniqueSerialNo,
  //           partKey: product.part_key,
  //           partType: product.part_type,
  //         })) || [];

  //       // Prepare updatedFormData
  //       const updatedFormData = {
  //         ...formData,
  //         paymentMethod: "stripe",
  //         paymentId: paymentIntent.id,
  //         subtotalAmount: subtotal,
  //         shippingCost: shippingCost,
  //         totalAmount: total,
  //         items: updatedItems,
  //       };

  //       console.log("Updated formData:", updatedFormData);
  //       const res = await addwebOrder(updatedFormData);

  //       if (res.data.success) {
  //         const ROWID = res.data.orderId;
  //         dispatch(addOrdersAction({ ROWID, formData: updatedFormData }));
  //         toast.success("Order created successfully");
  //         setOrderSubmitted(true);
  //         dispatch(clearCartApi(localStorage.getItem("UserRowId")));
  //       } else {
  //         toast.error("Error creating order");
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //     toast.error(error.message || "Payment failed");
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  const handleCityChange = (selectedCity) => {
    setCurrentCity(selectedCity);
    setFormData((prev) => ({
      ...prev,
      billingAddress: {
        ...prev.billingAddress,
        city: selectedCity.name,
      },
    }));
  };
  useEffect(() => {
    setDataOrder(getOrders);
  }, [getOrders]);
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await dispatch(getWebOrder(orderData));
        console.log("this is dataOrder list after that ", response);
      } catch (error) {
        console.error("Error fetching dataOrder :", error);
      }
    };

    fetchOrders();
  }, [dispatch]);

  useEffect(() => {
    if (currentStep === 3) {
      const handleStepChange = async () => {
        // console.log("formdata", formData);

        let totalWeight = 0;
        let totalHeight = 0;
        let totalWidth = 0;
        let totalLength = 0;

        formData.items.forEach((item) => {
          const qty = Number(item.quantity) || 1;
          totalWeight += (Number(item.weight) || 0) * qty;
          totalHeight += (Number(item.height) || 0) * qty;
          totalWidth += (Number(item.width) || 0) * qty;
          totalLength += (Number(item.length) || 0) * qty;
        });
        const paylod = {
          to_address: {
            name: formData.billingAddress.fullName ?? "",
            company: formData.billingAddress.company ?? "",
            address1: formData.billingAddress.address1 ?? "",
            address2: formData.billingAddress.address2 ?? "",
            city: formData.billingAddress.city ?? "",
            province_code: formData.billingAddress.province_code ?? "",
            postal_code: formData.billingAddress.postal_code ?? "",
            country_code: formData.billingAddress.country ?? "",
            phone: formData.billingAddress.phone ?? "",
            email: formData.billingAddress.email ?? "",
            is_residential: true,
          },
          return_address: {
            name: "Vancouver Auto Parts",
            company: "Vancouver Auto Parts",
            address1: "3511 Viking Way - Unit 10",
            address2: "SE #99470",
            city: "Richmond",
            province_code: "BC",
            postal_code: "V6V 1W1",
            country_code: "CA",
            phone: "6047735664",
            email: null,
            is_residential: false,
          },
          is_return: false,
          weight_unit: "lbs",
          weight: totalWeight || 1,
          length: totalLength || 3,
          width: totalWidth || 2,
          height: totalHeight || 2,
          size_unit: "in",

          items: formData.items.map((item) => ({
            description: item.partType || "No description",
            sku: item.uniqueSerialNo || "No SKU",
            quantity: item.quantity || 1,
            value: item.unitPrice || 0,
            currency: currency || "CAD",
            country_of_origin: formData.billingAddress.country ?? "CA",
            hs_code: item.hsCode || "123456",
            name: item.partType || "Unknown",
          })),
          package_type: "Parcel",
          postage_types: [],
          signature_confirmation: true,
          insured: false,
          region: null,
        };
        if (currentStep === 3) {
          try {
            setLoading(true);
            console.log("paylod", paylod);
            console.log("formdata", formData);
            const response = await getShippingPrice(paylod);
            console.log("this is shiping price res", response);
            if (response.success) {
              setShipstationData(response);
              console.log("setShipstationData", shipstationData);
              setSelectedShippingOption(response?.rates[0]);
              setLoading(false);
            }
          } catch (error) {
            setLoading(false);
            console.log("shipping error ", error);
          }
        }
      };

      handleStepChange();
    }
  }, [currentStep]);
  // this is all raletd to shipment  api
  const handleSubmitShipmentOrder = async () => {
    let totalWeight = 0;
    let totalHeight = 0;
    let totalWidth = 0;
    let totalLength = 0;

    formData.items.forEach((item) => {
      const qty = Number(item.quantity) || 1;
      totalWeight += (Number(item.weight) || 0) * qty;
      totalHeight += (Number(item.height) || 0) * qty;
      totalWidth += (Number(item.width) || 0) * qty;
      totalLength += (Number(item.length) || 0) * qty;
    });

    const payload = {
      store_id: "1234",
      name: formData.billingAddress.fullName ?? "",
      company: formData.billingAddress.company ?? "",
      address1: formData.billingAddress.address1 ?? "",
      address2: formData.billingAddress.address2 ?? "",
      city: formData.billingAddress.city ?? "",
      province_code: formData.billingAddress.province_code ?? "",
      postal_code: formData.billingAddress.postal_code ?? "",
      country_code: formData.billingAddress.country ?? "",
      phone: formData.billingAddress.phone ?? "",
      email: formData.billingAddress.email ?? "",
      is_residential: true,

      weight_unit: "lbs",
      weight: totalWeight || 1,
      height: totalHeight || 2,
      width: totalWidth || 2,
      length: totalLength || 3,
      value: priceSummaryData.Total || 0,
      currency: currency || "CAD",
      // order_id: uuidv4(),
      order_id: uuidv4().replace(/-/g, "").slice(0, 10),
      order_at: new Date().toISOString().slice(0, 19).replace("T", " "),
      store: "My Shopify Store",
      items: formData?.items.map((item) => ({
        item_id: item?.uniqueSerialNo || "",
        title: item?.partType || item.productName || "Unknown",
        sku: item?.uniqueSerialNo || "No SKU",
        hs_code: item?.hsCode || "123456",
        quantity: item?.quantity || 1,
        value: item?.unitPrice || 0,
        currency: currency || "CAD",
        country_of_origin: formData.billingAddress.country ?? "CA",
        warehouse_location: item?.warehouseLocation || "Warehouse A",
      })),
      // items: [
      //   {
      //     item_id: 1234,
      //     title: "Cool T-Shirt",
      //     sku: "SKU123",
      //     hs_code: "620800",
      //     quantity: 1,
      //     value: 10,
      //     currency: "CAD",
      //     country_of_origin: "CN",
      //     warehouse_location: "Warehouse A",
      //   },
      // ],
      tags: ["this is a tag", "this is another tag"],
    };

    try {
      console.log("shipemt order api payload ", payload);
      const resp = await ShipmentOrdersApi(payload);
      console.log("shipemt order api response ", resp);
      return resp;
    } catch (error) {
      console.log("shipment order api error ", error);
    }
  };

  const handleSubmitCreateShipment = async () => {
    let totalWeight = 0;
    let totalHeight = 0;
    let totalWidth = 0;
    let totalLength = 0;

    formData.items.forEach((item) => {
      const qty = Number(item.quantity) || 1;
      totalWeight += (Number(item.weight) || 0) * qty;
      totalHeight += (Number(item.height) || 0) * qty;
      totalWidth += (Number(item.width) || 0) * qty;
      totalLength += (Number(item.length) || 0) * qty;
    });

    const payload = {
      uuid: uuidv4(),
      shipmentPayload: {
        reference_number: "1234-1111",
        to_address: {
          name: formData.billingAddress.fullName ?? "",
          company: formData.billingAddress.company ?? "",
          address1: formData.billingAddress.address1 ?? "",
          address2: formData.billingAddress.address2 ?? "",
          city: formData.billingAddress.city ?? "",
          province_code: formData.billingAddress.province_code ?? "",
          postal_code: formData.billingAddress.postal_code ?? "",
          country_code: formData.billingAddress.country ?? "",
          phone: formData.billingAddress.phone ?? "",
          email: formData.billingAddress.email ?? "",
          is_residential: true,
        },
        return_address: {
          name: "Vancouver Auto Parts",
          company: "Vancouver Auto Parts",
          address1: "3511 Viking Way - Unit 10",
          address2: "SE #99470",
          city: "Richmond",
          province_code: "BC",
          postal_code: "V6V 1W1",
          country_code: "CA",
          phone: "6047735664",
          email: null,
          is_residential: false,
        },
        is_return: true,
        weight_unit: "lbs",
        weight: totalWeight || 1,
        length: totalLength || 3,
        width: totalWidth || 2,
        height: totalHeight || 2,
        size_unit: "cm",
        items: formData.items.map((item) => ({
          description: item.partType || item.productName || "No description",
          sku: item.uniqueSerialNo || "No SKU",
          quantity: item.quantity || 1,
          value: item?.totalPrice || (item.price || 0) * (item.quantity || 1),
          currency: currency || "CAD",
          country_of_origin: formData.billingAddress.country || "CA",
          hs_code: item.hsCode || "123456",
          manufacturer_name: "Vancouver Auto Parts",
          manufacturer_address1: "3511 Viking Way - Unit 10",
          manufacturer_city: "Richmond",
          manufacturer_province_code: "BC",
          manufacturer_postal_code: "V6V 1W1",
          manufacturer_country_code: "CA",
        })),
        package_type: selectedShippingOption?.package_type || "Parcel",
        signature_confirmation: false,
        postage_type:
          selectedShippingOption?.postage_type || "Canada Post Xpresspost",
        label_format: "pdf",
        is_fba: false,
        is_draft: true,
        insured: true,
        tax_identifier: {
          tax_type: "IOSS",
          number: "IM1234567890",
          issuing_authority: "GB",
        },
      },
    };
    console.log("this is the crateshipment payload ", payload);
    try {
      const response = await CreateShipmentApi(payload);
      console.log("this is crateshipment response ", response);
      return response;
    } catch (error) {
      console.log("this is crateshipment erro ", error);
    }
  };

  // useEffect(() => {
  //   if (shipstationData) {
  //     const shiping = shipstationData?.total;
  //     setPriceSummaryData((prv) => ({
  //       ...prv,
  //       Total: Number(shiping) + Number(subtotal) || 0,

  //       SubTotal: subtotal || 0,
  //       ShippingCost: shiping || 0,
  //     }));
  //   }
  // }, [shipstationData]);

  useEffect(() => {
    if (selectedShippingOption) {
      const shippingCost = selectedShippingOption.total;
      setPriceSummaryData({
        Total: Number(shippingCost) + Number(subtotal),
        SubTotal: subtotal,
        ShippingCost: shippingCost,
      });
      console.log("setPriceSummaryData", priceSummaryData);
      // Update formData with selected shipping
      setFormData((prev) => ({
        ...prev,
        shippingCost: shippingCost,
      }));
      console.log("fromdatttttttttaaaa", formData);

    }
  }, [selectedShippingOption, subtotal]);

  const shippingCost = priceSummaryData?.ShippingCost || 0;
  const total = priceSummaryData?.Total || 0;

  useEffect(() => {
    if (
      currentStep === 3 &&
      priceSummaryData.Total !== null &&
      priceSummaryData.Total !== undefined &&
      priceSummaryData.Total !== "" &&
      Number(priceSummaryData.Total) > 0
    ) {
      const createPaymentIntent = async () => {
        try {
          setIsLoading(true);
          const finaldata = {
            amount: priceSummaryData.Total, // Convert to cents
            currency: currency || "CAD",
          };
          console.log("finaldata", finaldata);
          const response = await PaymentCheckApi(finaldata);
          console.log("payment check ", response.clientSecret);
          setClientSecret(response.clientSecret);
          setIsLoading(false);
        } catch (error) {
          setIsLoading(false);
          toast.error("Error initializing payment");
        }
      };
      createPaymentIntent();
    }
  }, [currentStep, priceSummaryData.Total]);

  const handleSubmitAddress = async () => {
    const paylod = {
      customerId: localStorage.getItem("customerId"),
      firstName: formData.billingAddress.fullName?.split(" ")[0] || "",
      lastName:
        formData.billingAddress.fullName?.split(" ").slice(1).join(" ") || "",
      companyName: formData.billingAddress.company || "",
      country: formData.billingAddress.country || "",
      address: formData.billingAddress.address1 || "",
      town: formData.billingAddress.address2 || "",
      city: formData.billingAddress.city || "",
      state: formData.billingAddress.province_code || "",
      postalCode: formData.billingAddress.postal_code || "",
      phone: formData.billingAddress.phone || "",
      email: formData.billingAddress.email || "",
      addressType: "Billing",
    };

    try {
      const resp = await addCoustomerAddresses(paylod);
      console.log("resp", resp);
    } catch (error) {
      console.log("error", error);
    }
  };

  const OrderSuccess = ({ shipmentOrderId }) => (
    <div className="bg-white p-8 rounded-lg shadow-lg max-w-2xl mx-auto text-center relative overflow-hidden">
      {/* Decorative background elements */}
      {/* <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-r from-orange-400 to-blue-600" />
      <div className="absolute -top-20 -right-20 w-40 h-40 bg-green-100 rounded-full opacity-20" />
      <div className="absolute -bottom-20 -left-20 w-40 h-40 bg-blue-100 rounded-full opacity-20" /> */}

      <div className="relative z-1">
        {/* Animated checkmark */}
        <div className="mb-6 animate-bounce">
          <svg
            className="w-20 h-20 mx-auto text-green-500"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
              clipRule="evenodd"
            />
          </svg>
        </div>

        <h2 className="text-3xl font-bold text-blue-900 mb-3">
          🎉 Order Confirmed!
        </h2>
        <p className="text-lg text-gray-600 mb-6">
          Thank you for choosing us! We're preparing your order with care.
        </p>

        {/* Order details card */}
        <div className="bg-gray-50 p-6 rounded-lg text-left mb-8 border border-green-100">
          <div className="flex items-center mb-4">
            <svg
              className="w-6 h-6 text-green-500 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <h3 className="text-lg font-semibold">Order Summary</h3>
          </div>

          <div className="space-y-3">
            <div className="flex justify-between items-center">
              <span className="text-gray-600 font-semibold">Order Number:</span>
              {/* <span className="font-medium bg-green-100 px-2 py-1 rounded">#{latestOrder?.id}</span> */}
              <span className="font-medium bg-green-100 px-2 py-1 rounded">
                {shipmentOrderId}
              </span>
            </div>

            <div className="flex justify-between items-center">
              <span className="text-gray-600 font-semibold">
                <svg
                  className="w-5 h-5 inline-block mr-1 text-gray-600 font-semibold"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                  />
                </svg>
                Date:
              </span>
              <span>{new Date().toLocaleDateString()}</span>
            </div>

            <div className="flex justify-between items-center">
              <span className="text-gray-600 font-semibold">Total Amount:</span>
              <span className="font-semibold text-green-600">
                {/* ₹{total?.total?.toFixed(2)} */}
               ${Number(priceSummaryData?.Total).toFixed(2)}
              </span>
            </div>
          </div>
        </div>

        {/* Purchased items */}
        <div className="bg-white border rounded-lg p-6 mb-8">
          <div className="flex items-center mb-4">
            <svg
              className="w-6 h-6 text-blue-500 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
              />
            </svg>
            <h3 className="text-lg font-semibold">Your Purchases</h3>
          </div>
          {console.log("formdattttttt", formData)}
          {formData?.items?.map((item) => (
            <div
              key={item.uniqueSerialNo}
              className="flex items-center py-3 border-b last:border-none"
            >
              <img
                src={item.image   }
                alt={item.part_type}
                className="w-12 h-12 object-cover rounded-md mr-4 border"
              />
              <div className="flex-1 text-left">
                <p className="font-medium">{item.part_type}</p>
                <p className="text-sm text-gray-600">
                  {item.quantity} × ${item.unitPrice.toFixed(2)}
                </p>
              </div>
              <div className="text-right">
                <p className="font-medium text-gray-800">
                  ${item.totalPrice.toFixed(2)}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Next steps */}
        <div className="mb-8">
          <div className="flex items-center justify-center mb-4">
            <svg
              className="w-6 h-6 text-orange-500 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            {/* <h4 className="font-medium">What's Next?</h4> */}
          </div>
          {/* <p className="text-sm text-gray-600">
            You'll receive an order confirmation email shortly. Track your order
            status through our order tracking system.
          </p> */}
        </div>

        {/* Action buttons */}
        <div className="grid gap-4 sm:grid-cols-2">
          <button
            onClick={() => navigate("/shop")}
            className="bg-orange-500 text-white px-6 py-3 rounded-md hover:bg-orange-600 transition-all flex items-center justify-center"
          >
            <svg
              className="w-5 h-5 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
              />
            </svg>
            Continue Shopping
          </button>

          <button
            onClick={() => navigate("/account/orders")}
            className="bg-gray-100 text-gray-700 px-6 py-3 rounded-md hover:bg-gray-200 transition-all flex items-center justify-center"
          >
            <svg
              className="w-5 h-5 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
              />
            </svg>
            View Orders
          </button>
        </div>

        {/* Trust badges */}
        <div className="mt-8 pt-6 border-t border-gray-100">
          <div className="flex flex-wrap items-center justify-center gap-4 text-gray-500">
            <div className="flex items-center">
              <svg
                className="w-5 h-5 mr-1 text-green-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="text-sm">Secure Payment</span>
            </div>
            <div className="flex items-center">
              <svg
                className="w-5 h-5 mr-1 text-blue-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M3 17a2 2 0 01-2-2V5a2 2 0 012-2h4.586a2 2 0 011.414.586l1.121 1.121C11.461 4.974 12.739 4 14.172 4H17a2 2 0 012 2v11a2 2 0 01-2 2H3zm6.121-6.465a1 1 0 10-1.414-1.414l-.707.707a1 1 0 001.414 1.414l.707-.707zM14 9l-1.5-1.5 4-4L18 5l-4 4z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="text-sm">Quality Guaranteed</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  //  this is products card
  const renderProducts = () => (
    <div className="bg-white p-2 lg:mt-10  h-full  rounded-lg shadow-lg  lg:w-[90%]  w-[100%]  mx-auto text-center">
      <h4 className="lg:text-4xl md:text-3xl text-2xl font-semibold mb-2 border-b pb-2 text-blue-900">
        Your Order Details
      </h4>
      {cartItems?.map((item) => (
        <div
          key={item.uniqueSerialNo}
          className="flex justify-between items-center w-full border-b last:border-none "
        >
          <img
            src={item.image}
            alt={item.name}
            className="lg:w-36 md:w-36 w-[50vw] lg:h-[20vh] md:h-[10vh] h-[18vh] p-1   mr-6 mb-2 lg:p-2   object-contain rounded-lg  lg:ms-4 ms-2 mt-2"
            // className="w-20 h-[20vh] mr-6 mb-2 p-1  object-contain rounded-lg border ms-4 mt-2"
          />
          <div className="flex flex-col lg:w-10/12 md:w-9/12 w-10/12 mx-auto text-start mt-2   ">
            <div className="flex justify-between lg:mr-6 md:mr-6 mr-2 ">
              <p className="font-medium text-base">{item.name}</p>
              <p className="font-semibold text-gray-800 ">
                ${(item.price * item.quantity).toFixed(2)}
              </p>
            </div>
            <div className="flex justify-between text-sm text-gray-600 mt-1 lg:mr-6 md:mr-6 mr-2 ">
              <p>Qty: {item.quantity}</p>
              <p>Price: ${(item?.price)?.toFixed(2)}</p>
            </div>
          </div>
        </div>
      ))}
      <div className="flex flex-row-reverse justify-between mb-2">
        <button
          className="mt-4 bg-orange-500  text-white px-6 py-2 mr-5 rounded-full hover:bg-orange-600"
          onClick={() => setCurrentStep(2)}
        >
          Next
        </button>
        <button
          className="mt-4 bg-gray-200 font-semibold px-6  py-2 ml-5 rounded-full "
          onClick={() => navigate(-1)}
        >
          Back
        </button>
      </div>
    </div>
  );

  // Step 2: Address Selection
  const renderAddress = () => {
    const handleAddressSelect = (address) => {
      setSelectedAddress(address);
      setShowNewAddress(false);

      // Auto-fill form with selected address using to_address structure
      setFormData((prev) => ({
        ...prev,
        billingAddress: {
          ...prev.billingAddress,
          fullName: `${address.firstName} ${address.lastName}`,
          company: address.companyName || "",
          address1: address.address,
          address2: address.town || "",
          city: address.city,
          province_code: address.state,
          postal_code: address.postalCode,
          country: address.country,
          phone: address.phone,
          email: address.email,
          is_residential: true,
        },
      }));

      setCurrentStep(3);
    };

    return (
      <div className="bg-white p-4 lg:mt-10  h-full  rounded-lg shadow-lg  lg:w-[90%]  w-[100%]   mx-auto text-center">
        <p className="lg:text-4xl md:text-3xl text-2xl font-semibold mb-2 border-b pb-2 text-blue-900">
          Select Delivery Address
        </p>

        {!showNewAddress && userAddresses.length > 0 && (
          <div className="">
            <div className="flex justify-between items-center mb-4">
              <p className="lg:text-3xl md:text-2xl text-[19px] font-blod mt-3 ">
                Saved Addresses
              </p>
              <button
                className="flex items-center lg:text-xl md:text-xl text-[10px] text-white p-2 rounded-full bg-orange-500"
                onClick={() => setShowNewAddress(true)}
              >
                <svg
                  className="w-5 h-5 mr-1"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                  />
                </svg>
                Add New Address
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {userAddresses.map((address) => (
                <div
                  key={address.rowId}
                  className={`relative p-4 border-2 rounded-xl cursor-pointer transition-all
                  ${
                    selectedAddress?.rowId === address.rowId
                      ? "border-orange-500 bg-orange-50 shadow-sm"
                      : "border-gray-200 hover:border-blue-900"
                  }`}
                  onClick={() => handleAddressSelect(address)}
                >
                  {/* Default Address Badge */}
                  {address.defaultAddress && (
                    <div className="absolute top-2 right-2 bg-green-100 text-green-700 px-2 py-1 rounded-full text-xs flex items-center">
                      <svg
                        className="w-4 h-4 mr-1"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                      Default
                    </div>
                  )}

                  {/* Address Type Badge */}
                  <div className="mb-3">
                    <span
                      className={`inline-block px-3 py-1 rounded-full text-sm 
                    ${
                      address.addressType === "Shipping"
                        ? "bg-blue-100 text-blue-700"
                        : "bg-orange-500 text-white"
                    }`}
                    >
                      {address.addressType}
                    </span>
                  </div>

                  {/* Address Details */}
                  <div className="space-y-1.5 text-gray-700">
                    <p className="font-semibold text-2xl text-gray-900">
                      {address.firstName} {address.lastName}
                    </p>
                    <p>{address.address}</p>
                    <p>{address.apartment && `${address.apartment}, `}</p>
                    <p>
                      {address.city}, {address.state}
                    </p>
                    <p>
                      {address.country} - {address.postalCode}
                    </p>
                    {address.phone && <p>📱 {address.phone}</p>}
                    {/* {address.email?.trim() && <p>📧 {address.email}</p>} */}
                  </div>

                  {/* Selection Checkmark */}
                  {selectedAddress?.rowId === address.rowId && (
                    <div className="absolute bottom-2 right-2 text-orange-500">
                      <svg
                        className="w-6 h-6"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                  )}
                </div>
              ))}
            </div>
            <button
              className="mt-4 bg-gray-200 font-semibold px-6 flex justify-start  py-2 rounded-full "
              onClick={() => setCurrentStep(1)}
            >
              Back
            </button>
          </div>
        )}

        {(showNewAddress || userAddresses.length === 0) && (
          <form className="space-y-6">
            {/* Form Header */}
            <div className="border-b">
              <p className="text-xl font-semibold text-gray-700">
                {userAddresses.length === 0
                  ? "Add Your First Address"
                  : "Add New Address"}
              </p>
            </div>

            {/* Form Fields */}
            <div className="grid grid-cols-1 md:grid-cols-2 text-start gap-4">
              {/* First Name */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Full Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="billingAddress.fullName"
                  value={formData.billingAddress.fullName}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border rounded-lg"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Company (optional)
                </label>
                <input
                  type="text"
                  name="billingAddress.company"
                  value={formData.billingAddress.company || ""}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border rounded-lg "
                />
              </div>
              {/* Country/Region */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Country/Region <span className="text-red-500">*</span>
                </label>
                <CountrySelect
                  containerClassName="w-full border-none"
                  inputClassName="w-full px-4 py-1 rounded-lg border-none outline-none"
                  onChange={(country) => {
                    console.log("country", country);
                    setCountry(country);
                    setCurrency(country.currency);
                    setFormData((prev) => ({
                      ...prev,
                      billingAddress: {
                        ...prev.billingAddress,
                        country: country.iso2,
                      },
                    }));
                  }}
                  placeHolder="Select Country"
                  value={formData.billingAddress.country_code}
                  required
                />
              </div>

              {/* state */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  State <span className="text-red-500">*</span>
                </label>
                <StateSelect
                  countryid={country?.id}
                  containerClassName="w-full"
                  inputClassName="w-full px-4 py-1 rounded-lg border-none outline-none"
                  onChange={(state) => {
                    setCurrentState(state);
                    console.log("state", state);
                    setFormData((prev) => ({
                      ...prev,
                      billingAddress: {
                        ...prev.billingAddress,
                        province_code: state.state_code,
                      },
                    }));
                  }}
                  placeHolder="Select State"
                  value={formData.billingAddress.province_code}
                  disabled={!formData.billingAddress.country_code}
                  required
                />
              </div>

              {/* City */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  City <span className="text-red-500">*</span>
                </label>
                <CitySelect
                  countryid={country?.id}
                  stateid={currentState?.id}
                  containerClassName="w-full"
                  inputClassName="w-full px-4 py-1 rounded-lg border-none outline-none"
                  onChange={handleCityChange}
                  placeHolder="Select City"
                  // defaultValue={currentCity}
                  disabled={!currentState}
                  required
                />
              </div>
              {/* ZIP Code */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  ZIP Code <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="billingAddress.postal_code"
                  value={formData.billingAddress.postal_code}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border rounded-lg"
                  required
                />
              </div>

              {/* Modified Address Fields */}
              <div className="col-span-full">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Street Address <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="billingAddress.address1"
                  value={formData.billingAddress.address1}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border rounded-lg"
                  required
                />
              </div>

              <div className="col-span-full">
                <input
                  type="text"
                  name="billingAddress.address2"
                  value={formData.billingAddress.address2 || ""}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border rounded-lg "
                  placeholder="Apartment, suite, unit, etc. (optional)"
                />
              </div>

              {/* State
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  State <span className="text-red-500">*</span>
                </label>
                <StateSelect
                  countryid={country?.id}
                  containerClassName="w-full"
                  inputClassName="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  onChange={handleStateChange}
                  placeHolder="Select State"
                  // defaultValue={currentState}
                  disabled={!country}
                  required
                />
              </div> */}

              {/* Phone */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Phone Number <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  name="billingAddress.phone"
                  value={formData.billingAddress.phone}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border rounded-lg"
                  required
                />
              </div>

              {/* Email */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Email Address <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  name="billingAddress.email"
                  value={formData.billingAddress.email}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border rounded-lg "
                  // required
                />
              </div>
            </div>

            {/* Form Actions */}
            <div className="flex justify-between gap-2 w-full mt-8">
              <button
                type="button"
                className=" px-3 py-1 text-white whitespace-nowrap hover:bg-blue-800 font-medium lg:text-md md:text-md text-sm flex items-center border rounded-full bg-blue-900"
                onClick={() => (setCurrentStep(2), setShowNewAddress(false))}
              >
                <svg
                  className="w-4 h-5 mr-1"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
                Back 
              </button>
              <button
                type="button"
                className=" px-3 py-2 whitespace-nowrap bg-orange-500 hover:bg-orange-600 text-white  lg:text-md md:text-md text-sm rounded-full font-medium transition-colors"
                onClick={async () => {
                  await handleSubmitAddress(); // Save the new address
                  setCurrentStep(3); // Move to summary/payment step
                }}
                disabled={!formData.billingAddress.address1}
              >
                Continue to Payment
                <svg
                  className="w-4 h-5  ml-2 inline-block"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </button>
            </div>
          </form>
        )}
      </div>
    );
  };

  // const renderSummary = () => (
  //   <div className="bg-white p-6 rounded-lg shadow-md">
  //     <h4 className="text-lg font-semibold mb-4">Order Summary</h4>
  //     <div className="mb-6">
  //       <h5 className="font-medium mb-3">Shipping Options</h5>
  //       {shipstationData?.rates?.map((rate) => (
  //         <div
  //           key={rate.postage_type_id}
  //           className={`border rounded-md p-3 mb-2 cursor-pointer transition-all
  //           ${selectedShippingOption?.postage_type_id === rate.postage_type_id ? "border-orange-500 bg-orange-50 shadow-sm" : "border-gray-200 hover:border-orange-300"}`}
  //           onClick={() => setSelectedShippingOption(rate)}
  //         >
  //           <div className="flex justify-between items-center">
  //             <div>
  //               <div className="font-medium">{rate.postage_type}</div>
  //               <div className="text-sm text-gray-600">Est. delivery: {rate.delivery_days} days</div>
  //             </div>
  //             <div className="font-semibold">
  //               {rate.currency} {rate.total}
  //             </div>
  //           </div>

  //           {selectedShippingOption?.postage_type_id === rate.postage_type_id && (
  //             <div className="mt-2 text-sm text-green-600 flex items-center">
  //               <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
  //                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
  //               </svg>
  //               Selected
  //             </div>
  //           )}
  //         </div>
  //       ))}
  //     </div>
  //     <div className="mb-6">
  //       <h5 className="font-medium mb-2">Shipping Address</h5>
  //       <p>{formData.billingAddress.fullName}</p>
  //       <p>{formData.billingAddress.address1}</p>
  //       <p>
  //         {formData.billingAddress.city}, {formData.billingAddress.postal_code}
  //       </p>
  //       <p>{formData.billingAddress.country}</p>
  //     </div>

  //     <div className="border-t pt-4">
  //       <h5 className="font-medium mb-2">Order Details</h5>
  //       <ul className="border rounded-md text-sm">
  //         <li className="border-b p-2">
  //           Subtotal <span className="float-right">${priceSummaryData?.SubTotal}</span>
  //         </li>
  //         <li className="border-b p-2">
  //           Shipping <span className="float-right">${priceSummaryData?.ShippingCost}</span>
  //         </li>
  //         <li className="p-2">
  //           Total <span className="float-right font-semibold">${priceSummaryData?.Total}</span>
  //         </li>
  //         {/* <li className="border-b p-2">
  //           Delivered Day
  //           <span className="float-right">{shipstationData?.delivery_days ? `${shipstationData.delivery_days} day(s)` : "N/A"}</span>
  //         </li> */}
  //       </ul>

  //       {!showStripeForm ? (
  //         <button className="mt-4 bg-orange-500 text-white px-6 py-2 rounded hover:bg-orange-600" onClick={() => setShowStripeForm(true)}>
  //           Proceed to Payment
  //         </button>
  //       ) : (
  //         <StripePayment
  //           clientSecret={clientSecret}
  //           priceSummaryData={priceSummaryData}
  //           formData={formData}
  //           cartItems={cartItems}
  //           subtotal={subtotal}
  //           shippingCost={shippingCost}
  //           total={total}
  //           onSuccess={() => setOrderSubmitted(true)}
  //         />
  //       )}

  //       <div className="mt-6">
  //         <button className="bg-gray-200 text-gray-700 px-6 py-2 rounded hover:bg-gray-300" onClick={() => setCurrentStep(2)}>
  //           Back
  //         </button>
  //       </div>
  //     </div>
  //   </div>
  // );

  const renderSummary = () => (
    <div className="bg-white p-6 lg:mt-10 rounded-lg shadow-md lg:w-[90%] md:w-[99%]  w-[100%] mx-auto">
      <h4 className="lg:text-3xl md:text-3xl text-[22px] font-semibold mb-2 border-b pb-2 text-blue-900 text-center">
        Order Summary
      </h4>
      <div className="mb-6">
        <p className="font-semibold text-xl">Shipping Options</p>
        {loading ? (
          <div className="flex justify-center items-center py-8">
            <svg
              className="animate-spin h-8 w-8 text-orange-500"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v8z"
              ></path>
            </svg>
            <span className="ml-3 text-orange-500 font-medium">
              Loading shipping options...
            </span>
          </div>
        ) : (
          shipstationData?.rates?.map((rate) => (
            <div
              key={rate.postage_type_id}
              className={`border rounded-md p-3 mb-2 cursor-pointer transition-all
            ${
              selectedShippingOption?.postage_type_id === rate.postage_type_id
                ? "border-orange-500 bg-orange-50 shadow-sm"
                : "border-gray-200 hover:border-orange-300"
            }`}
              onClick={() => setSelectedShippingOption(rate)}
            >
              <div className="flex justify-between items-center">
                <div>
                  <div className="font-medium">{rate.postage_type}</div>
                  <div className="text-sm text-gray-600">
                    Est. delivery: {rate.delivery_days} days
                  </div>
                </div>
                <div className="font-semibold">
                  {rate.currency} {rate.total}
                </div>
              </div>

              {selectedShippingOption?.postage_type_id ===
                rate.postage_type_id && (
                <div className="mt-2 text-sm text-green-600 flex items-center">
                  <svg
                    className="w-4 h-4 mr-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  Selected
                </div>
              )}
            </div>
          ))
        )}
      </div>
      <div className="mb-6">
        <p className="font-semibold text-lg">Shipping Address</p>
        <p className="text-lg mb-0">{formData.billingAddress.fullName}</p>
        <p className="text-lg mb-0">{formData.billingAddress.address1}</p>
        <p className="text-lg mb-0">
          {formData.billingAddress.city}, {formData.billingAddress.postal_code}
        </p>
        <p>{formData.billingAddress.country}</p>
      </div>

      <div className="border-t pt-4">
        <p className="font-semibold text-xl">Order Details</p>
        <ul className="border rounded-lg text-base ps-0">
          <li className="border-b p-2 font-semibold">
            Subtotal{" "}
            <span className="float-right">
              ${Number(priceSummaryData?.SubTotal || 0).toFixed(2)}
              {console.log("priceSummaryData?.SubTotal", priceSummaryData)}
            </span>
          </li>
          <li className="border-b p-2 font-semibold">
            Shipping{" "}
            <span className="float-right">
              ${Number(priceSummaryData?.ShippingCost || 0).toFixed(2)}
            </span>
          </li>
          <li className="p-2 font-semibold">
            Total{" "}
            <span className="float-right font-semibold">
              ${Number(priceSummaryData?.Total).toFixed(2)}
            </span>
          </li>
        </ul>

        <div className="flex flex-row-reverse  justify-between">
          {!showStripeForm ? (
            <div className="flex flex-row-reverse items-center justify-between w-full">
              <button
                className="mt-4 bg-orange-500 text-white px-6 py-2 rounded-full hover:bg-orange-600 font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={() => setShowStripeForm(true)}
                disabled={priceSummaryData?.Total === 0 || !priceSummaryData?.Total}
              >
                Proceed to Payment
              </button>
              <button
            className="mt-4 bg-gray-200 font-semibold px-6 py-2 rounded-full "
            onClick={() => setCurrentStep(2)}
          >
            Back
          </button>   
            </div>
            
          ) : (
            <StripePayment
              clientSecret={clientSecret}
              priceSummaryData={priceSummaryData}
              formData={formData}
              cartItems={cartItems}
              subtotal={subtotal}
              shippingCost={shippingCost}
              total={total}
              handleSubmitCreateShipment={handleSubmitCreateShipment}
              handleSubmitShipmentOrder={handleSubmitShipmentOrder}
              onSuccess={() => setOrderSubmitted(true)}
              setShipmentOrderID={setShipmentOrderID}
              setCurrentStep={setCurrentStep}
            />
          )}

        
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className="bg-gray-100  lg:p-5 ">
        {orderSubmitted ? (
          <OrderSuccess shipmentOrderId={shipmentOrderId} />
        ) : (
          <div className="container mx-auto">
            <div className="mb-6">
              <div className="w-10/12 mx-auto ">
                <div className="flex items-center justify-between z-0    mt-3 relative">
                  {/* Progress line */}
                  <div className="absolute top-1/2 left-0 right-0 h-1 bg-gray-200 transform -translate-y-1/2">
                    <div
                      className="h-full bg-orange-500 transition-all duration-500 ease-out"
                      style={{ width: `${((currentStep - 1) / 2) * 100}%` }}
                    ></div>
                  </div>

                  {[1, 2, 3].map((step) => (
                    <div
                      key={step}
                      className="relative z-10 lg:mt-0 md:mt-10 mt-10 flex flex-col items-center"
                    >
                      {/* Step circle */}
                      <div
                        className={`
                          w-8 h-8 rounded-full lg:mb-0 mb-[40px] flex items-center justify-center
                          transition-colors duration-300
                          ${
                            currentStep >= step
                              ? "bg-orange-500 border-2 border-orange-500"
                              : "bg-white border-2 border-gray-300"
                          }
                       `}
                      >
                        {currentStep > step ? (
                          <svg
                            className="w-4 h-4 text-white"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                        ) : (
                          <span
                            className={`text-sm ${
                              currentStep >= step
                                ? "text-white"
                                : "text-gray-400"
                            }`}
                          >
                            {step}
                          </span>
                        )}
                      </div>

                      {/* Step label */}
                      <span
                        className={`
                        absolute top-10  text-sm font-medium
                        ${
                          currentStep >= step
                            ? "text-orange-500"
                            : "text-gray-400"
                        }
                         `}
                      >
                        {step === 1 && "Products"}
                        {step === 2 && "Address"}
                        {step === 3 && "Summary"}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              {currentStep === 1 && renderProducts()}
              {currentStep === 2 && renderAddress()}
              {currentStep === 3 && renderSummary()}
            </div>
          </div>
        )}
      </div>
      <style>{`
  .progress-container {
    @apply w-full mb-8;
  }
  
  .progress-steps {
    @apply flex items-center justify-between relative;
  }
  
  .progress-line {
    @apply absolute top-1/2 left-0 right-0 h-1 bg-gray-200 transform -translate-y-1/2;
  }
  
  .progress-fill {
    @apply h-full bg-orange-500 transition-all duration-500 ease-out;
  }
  
  .step-container {
    @apply relative z-10 flex flex-col items-center;
  }
  
  .step-circle {
    @apply w-8 h-8 rounded-full flex items-center justify-center 
           transition-colors duration-300 border-2;
  }
  
  .step-circle.active {
    @apply bg-orange-500 border-orange-500 text-white;
  }
  
  .step-circle.inactive {
    @apply bg-white border-gray-300 text-gray-400;
  }
  
  .step-label {
    @apply absolute top-full mt-3 text-sm font-medium;
  }
  
  .step-label.active {
    @apply text-orange-500;
  }
  
  .step-label.inactive {
    @apply text-gray-400;
  }
  
  .checkmark-icon {
    @apply w-4 h-4 text-white;
  }
`}</style>
      ;
    </>
  );
};

export default CheckoutPage;
